var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 200,
    viewBox: "0 0 182 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9947 186.639C43.674 181.748 25.5399 179.28 7.94866 177.02C4.15977 176.546 0.642048 179.19 0.371413 182.916C-0.169857 186.645 2.53808 190.054 6.05633 190.528C23.1063 192.704 40.696 195.033 57.2047 199.742C60.723 200.763 64.5135 198.661 65.596 195.044C66.6785 191.43 64.5129 187.663 60.9947 186.639Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.496 117.289C85.6202 88.662 54.2266 63.7197 26.8925 34.3244C24.4568 31.5791 20.1266 31.432 17.4202 33.9948C14.7139 36.5604 14.4443 40.8745 17.1507 43.6199C44.4848 73.0996 75.8784 98.1236 103.754 126.835C106.46 129.515 110.789 129.553 113.496 126.917C115.931 124.283 116.202 119.969 113.496 117.289Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.732 7.17864C166.544 23.5635 167.354 39.9484 168.166 56.3361C168.166 60.0891 171.415 62.987 175.204 62.8045C178.993 62.6193 181.698 59.4246 181.698 55.6688C180.886 39.2567 180.075 22.8472 179.264 6.43782C178.993 2.68476 175.745 -0.194035 171.956 0.0102319C168.438 0.214499 165.461 3.4283 165.732 7.17864Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeLines);
export default __webpack_public_path__ + "static/media/three-lines.6c4015866b82b1224078b4cd9f0f0280.svg";
export { ForwardRef as ReactComponent };